class ConsultaTributariaModal {
    constructor($scope, $filter, modal, ConsultaTributaria) {
        this.apply = fun => $scope.$apply(fun)
        this.$filter = $filter
        this.modal = modal
        this.ConsultaTributaria = ConsultaTributaria
    }

    $onInit() {
        this.consultarTributacao()
    }

    configurarIcms() {
        this.modal
            .open({
                component: 'configuracaoIcmsModal',
                size: 'lg',
                keyboard: 'static',
                resolve: {
                    empresaId: () => this.resolve.contratoId,
                    filialId: () => this.resolve.filialId
                }
            })
            .result
            .then(() => this.consultarTributacao())
    }

    configurarPisCofins() {
        this.modal
            .open({
                component: 'configuracaoPisCofinsModal',
                size: 'lg',
                keyboard: 'static',
                resolve: {
                    empresaId: () => this.resolve.contratoId,
                    filialId: () => this.resolve.filialId
                }
            })
            .result
            .then(() => this.consultarTributacao())
    }

    consultar(ncm) {
        this.resolve.ncm = ncm
        this.consultarTributacao()
    }

    consultarTributacao() {
        this.consulta = null

        const filtro = {
            exTipi: "",
            ncm: this.resolve.ncm.replace(/\D/g, ''),
            contrato: this.resolve.filialId
        }

        this.promise = this
            .ConsultaTributaria
            .consultaTributacao(filtro)
            .then(consulta => this.consulta = consulta)
            .catch(code => this.error = this.getMessage(code))
    }

    getMessage(code) {
        switch (code) {
            case 'ncm_inexistente':
                return `A NCM <strong>${this.resolve.ncm}</strong> não foi encontrada.`
            case 'cest_not_found':
                return 'Nenhuma CEST foi encontrada para o NCM informado.'
            default:
                return 'Ocorreu um erro ao carregar os dados.'
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("consultaTributariaModal", {
        controller: ['$scope', '$filter', '$uibModal', 'ConsultaTributaria', ConsultaTributariaModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal modal-title="Consulta Tributária" close="$ctrl.close">
            <modal-body>
                <ef-consulta-tributaria 
                    contrato-id="$ctrl.resolve.contratoId"
                    filial-id="$ctrl.resolve.filialId"
                    ncm="$ctrl.resolve.ncm"
                    consulta="$ctrl.consulta"
                    promise="$ctrl.promise"
                    error="$ctrl.error">
                </ef-consulta-tributaria>
            </modal-body>
            <modal-footer>
                <button type="button" class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
